import React from 'react';
import _get from 'lodash/get';
import { Html } from 'cccisd-wysiwyg';
import style from '../style.css';

const extractPrimitive = val => {
    if (val === null || val === undefined) return '';
    if (Array.isArray(val)) return val.map(extractPrimitive).join(', ');
    if (typeof val !== 'object') return String(val);
    if ('content' in val) return extractPrimitive(val.content);
    // fallback: try numeric keys (GraphQL scalar object shape {0,1,...,content,meta})
    const numericValues = Object.keys(val)
        .filter(k => !Number.isNaN(Number(k)))
        .sort((a, b) => Number(a) - Number(b))
        .map(k => val[k]);
    if (numericValues.length) return numericValues.join('');
    return '';
};

const toDisplayText = val => {
    const primitive = extractPrimitive(val);
    return typeof primitive === 'string' ? primitive : String(primitive || '');
};

const toAnswerText = val => {
    const parsed = parseFloat(val);
    if (Number.isNaN(parsed) || parsed < 0) return '';
    return toDisplayText(parsed.toFixed(1));
};

const VariableRender = ({ widget, metricsData, preMetricsData, answerBg, reportType }) => {
    const rawValue = _get(metricsData, `${widget.variable.reportHeader}`, '');
    const rawValueCount = _get(metricsData, `${widget.variable.reportHeader}Count`, '');

    const answerText = toAnswerText(rawValue);
    const nCount = toDisplayText(rawValueCount);
    const questionText = toDisplayText(widget.questionText);

    const preRawValue = _get(preMetricsData, `${widget.variable.reportHeader}`, '');
    const preRawValueCount = _get(preMetricsData, `${widget.variable.reportHeader}Count`, '');

    const preAnswerText = toAnswerText(preRawValue);
    const preNCount = toDisplayText(preRawValueCount);

    const totalValues = {
        Getting_to_the_Core: 26,
        Reclaiming_Possibilities_and_Hope: 16,
        Faith_in_Healing: 18,
        Trusting_Community_in_Healing: 12,
    };

    return (
        <>
            <Html content={questionText} />

            {reportType === 'post' && preMetricsData && (
                <p
                    className={`${style.answer} ${!preAnswerText ? style.empty : ''}`}
                    style={{ backgroundColor: answerBg }}
                >
                    <strong>Pre</strong>
                    <span>
                        {preAnswerText ? `${preAnswerText} out of ${totalValues[widget.variable.reportHeader]}` : ''}
                    </span>
                    <span className={style.nCount}>{preNCount ? `n=${preNCount}` : ''}</span>
                </p>
            )}
            <p className={`${style.answer} ${!answerText ? style.empty : ''}`} style={{ backgroundColor: answerBg }}>
                {reportType === 'post' && preMetricsData && <strong>Post</strong>}
                <span>{answerText ? `${answerText} out of ${totalValues[widget.variable.reportHeader]}` : ''}</span>
                <span className={style.nCount}>{nCount ? `n=${nCount}` : ''}</span>
            </p>
        </>
    );
};

export default VariableRender;
